import { render } from "./AddDetail.vue?vue&type=template&id=581da324&scoped=true"
import script from "./AddDetail.vue?vue&type=script&lang=js"
export * from "./AddDetail.vue?vue&type=script&lang=js"

import "./AddDetail.vue?vue&type=style&index=0&id=581da324&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581da324"]])

export default __exports__